// Instance
import MainAPI from '@/app/apis/main/main-api.js';

// Endpoints
import { API, ENDPOINTS } from '@/app/apis/main/_connection/connection-api.js';

// Query String
const queryString = require('querystring');

class StoreCreditAPI extends MainAPI {
	/**
	 * @return 204
	 * @params customerId
	 */
	async updateStoreCredit(customerId, creditDetails) {
		return API.put(`${ENDPOINTS.PUT_STORE_CREDIT}/update/${customerId}`, creditDetails);
	}
}

export default new StoreCreditAPI();